import script from "./RatingItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingItemCard.vue?vue&type=script&setup=true&lang=js"

import "./RatingItemCard.vue?vue&type=style&index=0&id=7dcca110&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcca110"]])

export default __exports__